import { useEffect, useCallback } from 'react'

export const useMoveByMouse = (element: HTMLElement | null) => {
  const handleMouseMove = useCallback(
    (e: MouseEvent) => {
      if (!element) return

      const xCenter = document.documentElement.clientWidth / 2 - e.pageX
      const yCenter = document.documentElement.clientHeight / 1.5 - e.pageY

      const elementCoord = element.getBoundingClientRect()
      const xElementCenter = elementCoord.x + elementCoord.width / 2
      const direction = document.documentElement.clientWidth / xElementCenter < 2 ? -1 : 1

      const x = Math.round((direction * xCenter) / 40)
      let y = Math.round(yCenter / 40)
      if (y < 0) y = -2

      element.style.transform = `translate(${x}px, ${y}px)`
    },
    [element]
  )

  useEffect(() => {
    if (window.innerWidth < 1000) return

    window.addEventListener('mousemove', handleMouseMove)

    return () => window.removeEventListener('mousemove', handleMouseMove)
  }, [handleMouseMove])
}
